import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IconButton } from 'material-ui';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import { Card } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import SmartGoCard from './SmartGoCard';
import {
  SMARTGO_STATUS,
  SMARTGO_ACCESS_CONTROL,
} from '../../../shared/utils/constants';

const SideBar = (props) => {
  const { t, toggle, dto, isOpen, handleSubmit } = props;

  return (
    <Fragment>
      <Card
        className={isOpen ? 'smartgo-sidebar-open' : 'smartgo-sidebar-close'}
      >
        <IconButton className="icon-button" onClick={toggle}>
          <CloseIcon />
        </IconButton>
        <List>
          <ListItem>
            <SmartGoCard smartGoCard={dto} />
          </ListItem>
          <ListItem>
            <div className="sidebar-list-content">{dto.responsibleName}</div>
          </ListItem>
          {dto.status !== SMARTGO_STATUS.STATUS_FINISHED &&
          dto.status !== SMARTGO_STATUS.STATUS_CANCELED ? (
            <>
              <ListItem>
                <Button
                  className="flex-grow-1 m-0"
                  color="primary"
                  onClick={() =>
                    handleSubmit(
                      dto,
                      SMARTGO_STATUS.STATUS_FINISHED,
                      SMARTGO_ACCESS_CONTROL.ENTRY
                    )
                  }
                >
                  {t('general.check_in')}
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  className="flex-grow-1 m-0"
                  color="warning"
                  onClick={() =>
                    handleSubmit(
                      dto,
                      SMARTGO_STATUS.STATUS_FINISHED,
                      SMARTGO_ACCESS_CONTROL.EXIT
                    )
                  }
                >
                  {t('general.check_out')}
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  className="flex-grow-1 m-0"
                  color="danger"
                  onClick={() =>
                    handleSubmit(dto, SMARTGO_STATUS.STATUS_CANCELED)
                  }
                >
                  {t('general.cancel_request')}
                </Button>
              </ListItem>
            </>
          ) : (
            <ListItem>
              <div className="sidebar-list-content flex-column align-items-start">
                <div className="d-flex mb-2">
                  <span className="bold-text">{t('general.status')}:</span>
                  <span className="pl-2">{t(`status.${dto.status}`)}</span>
                </div>
                {dto.status === SMARTGO_STATUS.STATUS_CANCELED ? (
                  <>
                    <div className="d-flex mb-2">
                      <span className="bold-text">
                        {t('general.canceled-by')}:
                      </span>
                      <span className="pl-2">{t(`${dto.updaterName}`)}</span>
                    </div>
                    <div className="d-flex mb-2">
                      <span className="bold-text">
                        {t('general.canceled-in')}:
                      </span>
                      <span className="pl-2">{dto.updatedAtMsFormated}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex mb-2">
                      <span className="bold-text">
                        {t('general.registry')}:
                      </span>
                      <span className="pl-2">{t(`${dto.registry}`)}</span>
                    </div>
                    <div className="d-flex mb-2">
                      <span className="bold-text">
                        {t('general.responsible-account')}:
                      </span>
                      <span className="pl-2">
                        {t(`${dto.responsibleName}`)}
                      </span>
                    </div>
                    <div className="d-flex mb-2">
                      <span className="bold-text">
                        {t('general.hour-time')}:
                      </span>
                      <span className="pl-2">{dto.hourNote}</span>
                    </div>
                    <div className="d-flex">
                      <span className="bold-text">
                        {t('general.registered-by')}:
                      </span>
                      <span className="pl-2">{t(`${dto.updaterName}`)}</span>
                    </div>
                  </>
                )}
              </div>
            </ListItem>
          )}
        </List>
      </Card>
    </Fragment>
  );
};

SideBar.propTypes = {
  t: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SideBar)
);
